<template>
	<v-row
		justify="space-between"
		align="start"
	>
		<v-col
			cols="12"
			md="6"
			lg="3"
			class="mb-3"
		>
			<v-text-field
				v-model="searchText"
				append-icon="search"
				label="חיפוש"
				single-line
				hide-details
				right
			/>
		</v-col>
		<v-col
			cols="12"
			md="6"
			lg="3"
			class="mb-3"
		>
			<v-select v-if="showTypes"
				v-model="type"
				:items="types"
				item-text="name"
				item-value="id"
				clearable
				outlined
				dense
				chips
				small-chips
        @change="test"
			/>
		</v-col>
		<v-col
			cols="12"
			md="6"
			lg="3"
			class="mb-3"
		>
			<v-autocomplete
				v-model="chosenTags"
				:items="tags"
				item-text="name"
				item-value="id"
				outlined
				dense
				chips
				small-chips
				clearable
				label="סינון לפי תגיות"
				multiple
			/>
		</v-col>
	</v-row>
</template>

<script>
import { types as tagTypes } from "src/store/modules/Tag.module";
import { types as typeTypes } from "src/store/modules/Type.module";

export default {
	name: "TableFilter",
  props:{
	  showTypes:{
	    type:Boolean,
      default: true
    },
    chosenImageType:{
	    required: false,
      default: null
    }
  },
	data () {
		return {
			searchText: null,
			chosenTags: [],
      type: null
		};
	},
  methods:{
	  test(type){
      this.$emit("type", type);
    }
  },
	computed: {
		tags () {
			return this.$store.state.TagModule.tags;
		},
		types () {
			return this.$store.state.TypeModule.types;
		},
	},
	watch: {
		searchText (newValue) {
			this.$emit("search", newValue);
		},
		chosenTags (newValue) {
			this.$emit("chosen-tags", newValue);
		},
    chosenImageType(newValue){
		  this.type = newValue;
    }
	},
	created () {
		this.type = this.$route.query.type_id;
		this.$store.dispatch(tagTypes.FETCH);
		this.$store.dispatch(typeTypes.FETCH);
	},
};
</script>
